import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const bkaclistService = {
  _url: `${process.env.REACT_APP_USER_API_URL}/domain-blacklist`,

  GetAllBlacListDomain(searchQuery, fetch) {
    const [domains, setDomains] = useState({
      domains: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [domainStatus, setDomainStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setDomainStatus(STATUS.LOADING);
      cancellablePromise(this.getAllBlacListDomain(searchQuery))
        .then(res => {
          setDomains(() => res);
          setDomainStatus(STATUS.SUCCESS);
        })
        .catch(() => setDomainStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);

    return {
      domains_loading: domainStatus === STATUS.LOADING,
      domains_error: domainStatus === STATUS.ERROR,
      domains_data: domains,
    };
  },

  async getAllBlacListDomain({
    page = 1,
    itemsPerPage = 10,
    searchText = '',
    getAll = false,
    startDate = '',
    endDate = '',
  }) {
    let res = await Fetch.get(
      `${this._url}/get-all?page=${page}&itemsPerPage=${itemsPerPage}&searchText=${searchText}&getAll=${getAll}&startDate=${startDate}&endDate=${endDate}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something Went Wrong');
  },

  async createBlackListDomain(payload) {
    let res = await Fetch.post(`${this._url}/create`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async deleteBlackListDomain(id) {
    let res = await Fetch.delete(`${this._url}/delete/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async updateBlackListDomain(id, payload) {
    let res = await Fetch.patch(`${this._url}/update/${id}`, payload);

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }

    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};
export default bkaclistService;
